import React, { useContext } from 'react'
import './contact.css'
import { BiCrown, BiEnvelope, BiLogOut, BiLogoWhatsapp, BiMobile, BiPhone } from 'react-icons/bi'
import { Link } from 'react-router-dom'
import { ContactContext } from '../../context/contactContext'

const Contact = () => {
    const {isContactOpen, setIsContactOpen} = useContext(ContactContext);

    const CloseContact = () =>{
        setIsContactOpen(false)
    }

  return (

    <div className={`contact_container ${isContactOpen === null ? '' : isContactOpen ? 'open' : 'closingb'}`}>
        <div className='contact_header'>
            <h1>how to find us</h1>
        </div>
        <div className='contact'>
            <h2><BiCrown className='crown'/>CEO/Executive Director: Daniel Mbongiseni Mahlangu</h2>
            <h2><BiPhone className='phone'/>: +27 13 170 5737 / 8</h2>
            <h2><BiLogoWhatsapp className='whatsapp'/>: <Link className='link_tag' to='https://wa.me/0823499920'><span className='whatsapp_span'>+27 82 349 9920</span></Link></h2>
            <h2><BiMobile className='mobile_phone'/>: +27 72 780 4673</h2>
            <h2><BiEnvelope className='envelope'/>: <Link className='link_tag' to='mailto:dnlmahlangu@gmail.com'><span className='email_span'>dnlmahlangu@gmail.com</span></Link></h2>
        </div>
        <div className='address_header'>
            <h1>Where we are</h1>
        </div>
        <div className='address'>
            <div className='address_title'>
                <h2>physical address</h2>
            </div>
            <div className='address_value'>
                <p>stand no: 668</p>
                <p>sun city a</p>
                <p>next to silamba secondary school</p>
                <p>kwa-mhlanga</p>
                <p>1022</p>
            </div>
        </div>
        <BiLogOut className='close_window' onClick={CloseContact}/>
    </div>
  )
}

export default Contact